/* eslint-disable */
import zzFetch from '@zz/fetch'
import { lego } from '@zz-common/lego'

//  缓存接口请求
let cacheLock = {}

/**
 * @description: 安全获取数据
 * @param {*} data 请求返回的数据
 * @param {*} param 参数名称 支持递归、例如：a.b 或者 ['a','b'] 获取返回data.a.b
 * @param {*}  defaultValue 默认值，参数不存在或者没有事返回
 * @return {*}
 */
function getParamData(data) {
  return (param, defaultValue = null) => {
    let arr = []
    if (Array.isArray(param)) {
      arr = param
    } else {
      arr = param.replace(/\[/g, '.').replace(/\]/g, '').split('.')
    }
    let res = arr.reduce((t, c) => (t || {})[c], data || {}) || defaultValue
    return res
  }
}

class Fetch {
  /**
   * 发送请求
   * @param  {string} method     （必）请求地址
   * @param  {object} url    （可）请求参数
   * @param  {object} params    （可）请求参数
   * @param  {object} opts    （可）request附加参数
   * @return {promise}
   */
  static request(method, url, params = {}, opts = {}, lock) {
    if (lock) {
      if (cacheLock[url] && cacheLock[url] === '1') {
        return Promise.reject(new Error('正在请求中，请稍等~'))
      }
      cacheLock[url] = '1'
    }

    return new Promise((resolve, reject) => {
      // 因为zzFetch内部的hasCsrfToken是全局变量，且通过opts.csrfToken来判断，是否使用已存
      // 之所以这么是是因为zz-fetch内部关于csrfToken的赋值逻辑有漏洞。未来zz-fetch升级后，可以删除本代码
      if (opts.csrfToken === undefined) {
        opts.csrfToken = true
      }

      // 发送请求
      zzFetch({
        url: url,
        method: method,
        params: params,
        cancelType: 2,
        ...opts,
      })
        .then((resp) => {
          let rst = resp.data || resp.respData || {}
          // 添加安全获取返回数据方法
          const get = getParamData(rst)
          rst = {
            get,
            data: { ...rst },
          }
          // 请求成功
          if (resp.respCode - 0 === 0) {
            // 直接返回数据
            resolve(rst)
          } else {
            // Toast(resp.errorMsg || resp.errMsg || '网络开小差了，请稍后重试')
            lego.send({
              pagetype: 'NEW_DETAIL_REQUEST_LEGO',
              actiontype: 'NEW_DETAIL_API_ERROR',
              backup: {
                respCode: resp.respCode,
                respData: resp.respData,
                errMsg: resp.errorMsg || resp.errMsg,
                type: 'new_net-zero',
                url: url,
              },
            })
            reject({
              respCode: resp.respCode,
              errorMsg: resp.errorMsg || resp.errMsg,
            })
          }
        })
        .catch((err = {}) => {
          // Toast('网络开小差了，请稍后重试吧')
          lego.send({
            pagetype: 'NEW_DETAIL_REQUEST_LEGO',
            actiontype: 'NEW_DETAIL_API_ERROR',
            backup: {
              url,
              method,
              params,
              cancelType: 2,
              ...opts,
              type: 'new_api-error',
              err: JSON.stringify(err),
            },
          })
        })
        .finally(() => {
          cacheLock[url] && (cacheLock[url] = '0')
        })
    })
  }

  /**
   * jsonp请求
   * @param  {string} obj     （必）请求地址
   * @return {promise}
   */
  static jsonp(obj) {
    const { url, params, opts, lock } = obj
    return Fetch.request('jsonp', url, params, opts, lock)
  }

  /**
   * get请求
   * @param  {string} obj     （必）请求地址
   * @return {promise}
   */
  static get(obj) {
    const { url, params, opts, lock } = obj
    return Fetch.request('get', url, params, opts, lock)
  }

  /**
   * post请求
   * @param  {string} obj     （必）请求地址
   * @return {promise}
   */
  static post(obj) {
    const { url, params, opts, lock } = obj
    return Fetch.request('post', url, params, opts, lock)
  }
}

export default Fetch
